import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { FaPlus, FaBell } from "react-icons/fa";
import AlertFormModal from "@/features/alerts/alert-form-modal";

/**
 * NewAlertButton component - a button to create a new alert.
 * Opens the AlertFormModal when clicked.
 */
const NewAlertButton: React.FC = () => {
  const [isHovered, setIsHovered] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleClick = () => {
    setIsModalOpen(true);
  };

  return (
    <>
      <motion.button
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
        onClick={handleClick}
        whileHover={{ scale: 1.02 }}
        whileTap={{ scale: 0.98 }}
        className="w-full flex items-center gap-2 px-3 py-2.5 rounded-xl text-[var(--arc-sidebar-text-secondary)] hover:text-[var(--arc-sidebar-text-primary)] hover:bg-[var(--arc-sidebar-accent-glow)] transition-all"
      >
        {/* Plus Icon with Animation */}
        <div className="relative flex items-center justify-center w-5 h-5">
          <motion.div
            animate={{
              rotate: isHovered ? 90 : 0,
            }}
            transition={{ duration: 0.2 }}
          >
            <FaPlus className="text-sm" />
          </motion.div>
        </div>

        {/* Button Text */}
        <div className="flex items-center gap-2 flex-1">
          <span className="text-sm font-medium">Nouvelle alerte</span>
          <AnimatePresence>
            {isHovered && (
              <motion.div
                initial={{ opacity: 0, scale: 0.8 }}
                animate={{ opacity: 1, scale: 1 }}
                exit={{ opacity: 0, scale: 0.8 }}
                transition={{ duration: 0.15 }}
              >
                <FaBell className="text-xs text-amber-500" />
              </motion.div>
            )}
          </AnimatePresence>
        </div>
      </motion.button>

      {/* Alert Form Modal */}
      <AlertFormModal
        open={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        editingAlert={null}
      />
    </>
  );
};

NewAlertButton.displayName = "NewAlertButton";

export default NewAlertButton;
